export default "__VITE_ASSET__BgAOG1pS__"